import { FileText, Search, Shield, Home, Briefcase, Clock } from "lucide-react";

export const Services = () => {
  const services = [
    {
      icon: Search,
      title: "Title Search & Examination",
      description: "Comprehensive title searches conducted by experienced professionals who understand what to look for and how to resolve issues before they delay your closing.",
    },
    {
      icon: Shield,
      title: "Title Insurance",
      description: "Protection backed by First American and Fidelity, two of the world's largest underwriters. Our attorney relationships often secure exceptions others cannot.",
    },
    {
      icon: FileText,
      title: "Settlement Services",
      description: "From contract to closing, we coordinate every detail. Our proactive communication ensures all parties stay informed and prepared.",
    },
    {
      icon: Home,
      title: "Residential Closings",
      description: "Whether it's a first-time buyer or a luxury property, we bring the same level of expertise and attention to every transaction.",
    },
    {
      icon: Briefcase,
      title: "Commercial Transactions",
      description: "Complex deals require sophisticated title work. Our attorneys handle multi-party transactions, easements, and unusual title situations with confidence.",
    },
    {
      icon: Clock,
      title: "Refinance Services",
      description: "Fast, efficient refinance closings that keep your deals moving. We understand lender requirements and time-sensitive deadlines.",
    },
  ];

  return (
    <section id="services" className="py-24 lg:py-32 bg-white" data-testid="services-section">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        {/* Section Header */}
        <div className="max-w-2xl mb-16">
          <p className="text-xs font-bold uppercase tracking-widest text-[#B45309] mb-4">Our Services</p>
          <h2 className="font-serif text-4xl md:text-5xl font-medium text-[#0F172A] tracking-tight mb-6">
            Complete Title Solutions
          </h2>
          <p className="text-lg text-[#64748B] leading-relaxed">
            From first search to final signature, we handle every aspect of your title and closing needs 
            with the precision and care your clients deserve.
          </p>
        </div>

        {/* Bento Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {services.map((service, index) => (
            <div
              key={index}
              className="group p-8 bg-[#FAFAF9] border border-[#E7E5E4] hover:border-[#0F172A]/20 card-shadow cursor-pointer"
              data-testid={`service-card-${index}`}
            >
              <div className="w-12 h-12 flex items-center justify-center bg-[#0F172A] text-white mb-6 group-hover:bg-[#B45309] btn-transition">
                <service.icon className="w-5 h-5" strokeWidth={1.5} />
              </div>
              <h3 className="font-serif text-xl font-medium text-[#0F172A] mb-3">
                {service.title}
              </h3>
              <p className="text-[#64748B] leading-relaxed text-sm">
                {service.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};
